import List from '../components/list.js';
import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import { Link } from 'react-router-dom';
import axios from 'axios';

const TemplateList = () => {
    const [templates, setTemplates] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const setContext = useContext(Context)[1];
    const { role, metaData } = useContext(AccessContext);
    const [checks, setChecks] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    setContext('Email Templates');
    const templateList = [
        {
            typeId: 'claim_podcast',
            updatedAt: ''
        },
        {
            typeId: 'forgot_password',
            updatedAt: ''
        },
        {
            typeId: 'podcast_join',
            updatedAt: ''
        },
        {
            typeId: 'host_guest_join',
            updatedAt: ''
        },
    ]
    var headings = [
        { key: 'typeId', name: 'ID', link: true, linkKey: 'typeId' },
        { key: 'updatedAt', name: 'Last Updated' }
    ];
    useEffect(() => {
        if (role == 'Host/Guest')
            loadTemplates();
    }, [role])
    const loadTemplates = () => {
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'email/templates', {
            action: 'SELECT_ALL'
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                const data = r.data.results.map(d => {
                    d.updatedAt = (new Date(d.updatedAt)).toLocaleDateString('en-US', {
                        hour: 'numeric',
                        minute: 'numeric',
                        timeZone: 'UTC'
                    });
                    return d;
                });

                const dbMap = new Map(data.map(obj => [obj.typeId, obj]));

                const combinedArray = templateList.map(baseObj => {
                    return dbMap.get(baseObj.typeId) || baseObj;
                });
                console.log(combinedArray);

                setTemplates(combinedArray);
            }
        });
    }
    const deleteTemplates = () => {
        let ids = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.push(templates[i].typeId);
            }
            return acc
        }, []);
        if (ids.length === 0)
            return;
        
        setLoading(true);
        setTemplates([]);
        var promises = [];
        ids.forEach(id => {
            promises.push(axios.post(process.env.REACT_APP_API_URL + 'email/templates', {
                action: 'DELETE',
                type: id
            }));
        });
        Promise.all(promises)
            .then(r => {
                setLoading(false);
                if (r?.data?.status === 'Success') {
                    loadTemplates();
                    setChecks(Array.apply(null, Array(templateList?.length)).map(() => false));
                }
            });
    }
    useEffect(() => {
        loadTemplates();
    }, []);
    useEffect(() => {
        setChecks(Array.apply(null, Array(templateList?.length)).map(() => false));
    }, [templates]);
    return (
        <main>
            <div className="container w-100">
                <div className="form mb-10">
                    <div className="mw-300 w-100 gap-15 f-row">
                        <button className="link-styles" onClick={deleteTemplates}>Delete</button>
                    </div>
                </div>
                <List list={templates} href="template-builder" headings={headings} loading={loading} onCheck={setChecks} />
            </div>
        </main>
    )
}

export default TemplateList;